import { useTranslation } from 'react-i18next'

const CostTag = ({ title, amount =0 }: any) => {
    const { t } = useTranslation()
    return (
        <div className='col-sm-4 text-center font-size-14  m-auto' >
            <div >
                {t(title)}
            </div>
            {amount.toFixed(2)}
        </div>
    )
}

export default CostTag